import { GADimension } from '@ps/web-core-enums';
import { setCustomUrl, trackPageView } from '@snowplow/browser-tracker';
import ReactGA from 'react-ga';

import type { TrackingContextValue } from '../providers/TrackingContext';

export const pageView = (_context: TrackingContextValue, pathname: string, title?: string) => {
  title ? ReactGA.pageview(pathname, undefined, title) : ReactGA.pageview(pathname);
  ReactGA.set({ [GADimension.PageOriginPath]: pathname });
  setCustomUrl(pathname);
  title ? trackPageView({ title }) : trackPageView();
};
